module.exports = __webpack_public_path__ + "img/fatherhood_9.b8d28d00.jpg";